import i18n from '@i18next/i18n';
import { DEFAULT_FONT_FAMILY } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/editor-constants';
import { CUSTOM } from '@src/slide/infrastructure/module/dependent/config/tob/constant';


export const AUDIO_DEFAULT_IMG = CUSTOM.ATTACHMENT.DEFAULT_AUDIO_IMAGE;

export const VIDEO_DEFAULT_IMG = CUSTOM.ATTACHMENT.DEFAULT_VIDEO_IMAGE;

// 一像素的透明图片，可以用于渲染占位
export const TRANSPARENT_PIXEL_BASE64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
export const TRANSPARENT_PIXEL_PNG = 'https://docimg3.docs.qq.com/image/AgAABTqRgqtHTjP5RydN4YU5S0F1AoQm.png';

// 跨文档粘贴图片附件时的占位图
export const IMAGE_ATTACHMENT_PASTE_PLACEHOLDER = 'https://docimg1.docs.qq.com/image/AgAABTqRgqvbR-Hg4UBDcYlT0Jywjkc3.png?w=1318&h=408';

export const MAX_MEDIA_SIZE = 500 * 1024 * 1024;  // 最大音视频字节数500M

// 文字链默认样式
export const TEXT_LINK_DEFAULT_FONT_FAMILY = 'PingFang SC';
export const TEXT_LINK_DEFAULT_COLOR = '#175ceb';
export const TEXT_LINK_DEFAULT_FONT_SIZE = 14;

// 这个是文字链最终生效的字体列表，后面的 DEFAULT_FONT_FAMILY 是 canvas 文字默认的备用字体
export const TEXT_LINK_EFFECT_FONT_FAMILY = [TEXT_LINK_DEFAULT_FONT_FAMILY, ...DEFAULT_FONT_FAMILY];

// 附件分类
export enum AttachmentClassify {
    VIDEO = 'video',
    AUDIO = 'audio',
    DOC = 'doc',
    IMAGE = 'image',
}
export const AttachmentClassifyArray = [
    AttachmentClassify.VIDEO,
    AttachmentClassify.AUDIO,
    AttachmentClassify.DOC,
    AttachmentClassify.IMAGE,
];

// 附件组件的多种展示形态
export enum EShowType {
    SIMPLE_TEXT = 'simpleText',
    TEXT = 'text',
    CARD = 'card',
    NONE = 'none',
    PREVIEW = 'preview',
}

export enum EChangePosterType {
    FROM_LOCAL_FILE = 'fromLocalFile',
    FROM_CLIPBOARD = 'fromClipboard',
    FROM_CUR_FRAME = 'fromCurFrame'
}

export const FROM_LOCAL_FILE_CONFIG = {
    id: EChangePosterType.FROM_LOCAL_FILE,
    title: i18n.t('从本地文件'),
};

export const FROM_CLIPBOARD_CONFIG = {
    id: EChangePosterType.FROM_CLIPBOARD,
    title: i18n.t('来自剪贴板'),
};

export const FROM_CUR_FRAME_CONFIG = {
    id: EChangePosterType.FROM_CUR_FRAME,
    title: i18n.t('当前帧'),
};

export enum EResetPosterType {
    RESET_POSTER_SELF = 'resetPosterSelf',
    RESET_POSTER_SIZE = 'resetPosterSize'
}

export const RESET_POSTER_SELF_CONFIG = {
    id: EResetPosterType.RESET_POSTER_SELF,
    title: i18n.t('重置封面'),
};

export const RESET_POSTER_SIZE_CONFIG = {
    id: EResetPosterType.RESET_POSTER_SIZE,
    title: i18n.t('重置封面及大小'),
};

export const SIMPLE_TEXT_CONFIG = {
    id: EShowType.SIMPLE_TEXT,
    title: i18n.t('文字链'),
};

export const ICON_TEXT_CONFIG = {
    id: EShowType.TEXT,
    title: i18n.t('图标+文字链'),
};

export const PREVIEW_CONFIG = {
    id: EShowType.PREVIEW,
    title: i18n.t('预览'),
};

export const CARD_CONFIG = {
    id: EShowType.CARD,
    title: i18n.t('卡片'),
};


export const ShowTypeTrans = {
    [EShowType.SIMPLE_TEXT]: SIMPLE_TEXT_CONFIG.title,
    [EShowType.TEXT]: ICON_TEXT_CONFIG.title,
    [EShowType.CARD]: CARD_CONFIG.title,
};

// 默认视频尺寸
export const DEFAULT_VIDEO_WIDTH = 710;
export const DEFAULT_VIDEO_HEIGHT = 448;

// 默认音频尺寸
export const DEFAULT_AUDIO_WIDTH = 135;
export const DEFAULT_AUDIO_HEIGHT = 135;

// 默认图片附件尺寸
export const DEFAULT_IMAGE_WIDTH = 710;
export const DEFAULT_IMAGE_HEIGHT = 448;

// 卡片类型默认尺寸
export const DEFAULT_CARD_WIDTH = 710;
export const DEFAULT_CARD_HEIGHT = 120;

// 文字链类型默认尺寸
export const DEFAULT_TEXT_WIDTH = 300;
export const DEFAULT_TEXT_HEIGHT = 50;

// gif 后缀
export const GIF_EXT = 'gif';


/**
 * 标记播放器状态
 * 这是 SuperPlayer 中的类型，slide 没有直接依赖 SuperPlayer，理论上应该由 dc 提供，现在 dc 不支持提供，所以暂时 copy 了一份
 * @enum {string}
 */
export enum VIDEO_STATE {
    IDLE = 'idle',
    LOAD_START = 'loadStart',
    /** 当浏览器能够开始播放指定的音频/视频时，但尚未开始播放 */
    CANPLAY = 'canplay',
    PLAYING = 'playing',
    PAUSE = 'pause',
    SEEKING = 'seeking',
    SEEKED = 'seeked',
    BUFFERING = 'buffering',
    /** 正常播放结束（包括外部中断播放），如果是播放出错则没有此状态 */
    END = 'end'
}

/**
 * 标准播放流程事件
 * 这是 SuperPlayer 中的类型，slide 没有直接依赖 SuperPlayer，理论上应该由 dc 提供，现在 dc 不支持提供，所以暂时 copy 了一份
 */
export enum H5_PLAY_EVENT {
    /** 单次播放会话开始 在load/play时开始 */
    PLAY_SESSION_START = 'PLAY_SESSION_START',
    /** 请求广告信息开始 */
    AD_REQ_INFO_START = 'AD_REQ_INFO_START',
    /** 广告信息返回成功/失败 */
    AD_REQ_INFO_END = 'AD_REQ_INFO_END',
    /** 请求广告素材开始 */
    AD_REQ_ASSETS_START = 'AD_REQ_ASSETS_START',
    /** 广告自动播放被拦截 */
    AD_AUTOPLAY_BLOCKED = 'AD_AUTOPLAY_BLOCKED',
    /** 广告开始播放 */
    AD_PLAYING = 'AD_PLAYING',
    /** 广告音量变化 */
    AD_VOLUME_CHANGE = 'AD_VOLUME_CHANGE',
    /** 广告素材加载完成 */
    AD_ASSETS_LOADED = 'AD_ASSETS_LOADED',
    /** 广告播放暂停 */
    AD_PAUSE = 'AD_PAUSE',
    /** 广告恢复播放 */
    AD_RESUME = 'AD_RESUME',
    /** 广告播放完成/失败	 */
    AD_END = 'AD_END',
    AD_TIME_UPDATE = 'AD_TIME_UPDATE',
    /** 请求正片信息开始 */
    VIDEO_REQ_INFO_START = 'VIDEO_REQ_INFO_START',
    /** 请求正片信息结束，成功/失败 */
    VIDEO_REQ_INFO_END = 'VIDEO_REQ_INFO_END',
    /** 开始加载正片 */
    VIDEO_LOAD_START = 'VIDEO_LOAD_START',
    /** 正片数据加载中 */
    VIDEO_LOAD_PROGRESS = 'VIDEO_LOAD_PROGRESS',
    /** 正片时长变化 */
    VIDEO_DURATION_CHANGE = 'VIDEO_DURATION_CHANGE',
    /** 正片信息变化 */
    VIDEO_METADATA_CHANGE = 'VIDEO_METADATA_CHANGE',
    /** 正片播放进度变化 */
    VIDEO_TIMEUPDATE = 'VIDEO_TIMEUPDATE',
    /** 正片音量变化 */
    VIDEO_VOLUME_CHANGE = 'VIDEO_VOLUME_CHANGE',
    /** 正片倍速变化 */
    VIDEO_RATE_CHANGE = 'VIDEO_RATE_CHANGE',
    /** 正片可以播放 */
    VIDEO_CANPLAY = 'VIDEO_CANPLAY',
    /** 正片开始播放 */
    VIDEO_PLAYING = 'VIDEO_PLAYING',
    /** 正片自动播放被拦截 */
    VIDEO_AUTOPLAY_BLOCKED = 'VIDEO_AUTOPLAY_BLOCKED',
    /** 正片暂停播放 */
    VIDEO_PAUSE = 'VIDEO_PAUSE',
    /** 正片缓冲中 */
    VIDEO_BUFFERING = 'VIDEO_BUFFERING',
    /** 正片跳转中 */
    VIDEO_SEEKING = 'VIDEO_SEEKING',
    /** 正片跳转结束 */
    VIDEO_SEEKED = 'VIDEO_SEEKED',
    /** 正片切换清晰度开始 */
    VIDEO_SETLEVEL_START = 'VIDEO_SETLEVEL_START',
    /** 正片切换清晰度结束 */
    VIDEO_SETLEVEL_END = 'VIDEO_SETLEVEL_END',
    /** 视频分辨率发生变化 */
    VIDEO_RESIZE = 'VIDEO_RESIZE',
    /** 正片播放结束 */
    VIDEO_END = 'VIDEO_END',
    /** 单次播放会话结束 */
    PLAY_SESSION_END = 'PLAY_SESSION_END'
}
